function ImportedOpeningRecoveryView({ issue, onRecovered, correction = false }: { issue: any; onRecovered: () => Promise<void>; correction?: boolean }) {
  const [proposal, setProposal] = React.useState<any>(null);
  const [busy, setBusy] = React.useState(false);
  const [confirmed, setConfirmed] = React.useState(false);
  const [error, setError] = React.useState('');
  const [reason, setReason] = React.useState('');
  const operationId = React.useRef('');
  const preview = async () => {
    setBusy(true); setError(''); setConfirmed(false);
    try {
      const result = await window.PlummeAccountingJournalRecovery.requestImportedOpening(issue.businessId, issue.year, undefined, correction);
      operationId.current = crypto.randomUUID(); setProposal(result.proposal);
    } catch (error: any) { setError(error.message); } finally { setBusy(false); }
  };
  const complete = async () => {
    setBusy(true); setError('');
    try {
      await window.PlummeAccountingJournalRecovery.requestImportedOpening(issue.businessId, issue.year, {
        confirmed, sourceHash: proposal.sourceHash, operationId: operationId.current, ...(correction ? { reason } : {}),
      }, correction);
      setProposal(null); await onRecovered();
    } catch (error: any) { setError(error.message); } finally { setBusy(false); }
  };
  return <div className="mt-16">
    {!correction && <p>{t('journalRecovery.importedOpeningHelp')}</p>}
    <Button disabled={busy} onClick={preview}>{t(correction ? 'journalRecovery.reviewCorrection' : 'journalRecovery.reviewOpening')}</Button>
    {error && <p role="alert">{error}</p>}
    <Modal open={Boolean(proposal)} onClose={() => { if (!busy) setProposal(null); }} title={t(correction ? 'journalRecovery.reviewCorrection' : 'journalRecovery.reviewOpening')} max={850}
      footer={<Button disabled={busy || !confirmed || (correction && reason.trim().length < 5)} onClick={complete}>{t(correction ? 'journalRecovery.postCorrection' : 'journalRecovery.postOpening')}</Button>}>
      {proposal && <div>
        {error && <p role="alert">{error}</p>}
        <p>{t('journalRecovery.openingFromYear', { year: proposal.sourceYear, date: PlummeI18n.date(proposal.transitionDate) })}</p>
        {correction && <div>
          <p>{t('journalRecovery.correctionExplanation')}</p>
          <div className="tbl-wrap"><table className="tbl"><thead><tr><th></th>{['previous', 'next', 'difference'].map(key => <th key={key}>{t(`journalRecovery.${key}`)}</th>)}</tr></thead><tbody>
            {proposal.changes.map((row: any) => <tr key={row.accountCode}><td>{row.accountCode}</td>{['previous', 'next', 'difference'].map(key => <td className="num" key={key}>{PlummeI18n.number(row[key], { minimumFractionDigits: 2 })}</td>)}</tr>)}
          </tbody></table></div>
          <p className="text-muted">{t('journalRecovery.signedAmounts')}</p>
          <label className="field mt-16">{t('journalRecovery.correctionReason')}<textarea className="input" rows={2} style={{ width: '100%', display: 'block' }} value={reason} maxLength={1000} onChange={(event: any) => setReason(event.target.value)}/></label>
        </div>}
        <div className="tbl-wrap"><table className="tbl"><thead><tr><th></th><th>{t('journalRecovery.debit')}</th><th>{t('journalRecovery.credit')}</th></tr></thead><tbody>{proposal.lines.map((line: any) => <tr key={line.accountCode}>
          <td>{line.accountCode} {line.accountName}</td><td className="num">{PlummeI18n.number(line.debit, { minimumFractionDigits: 2 })}</td><td className="num">{PlummeI18n.number(line.credit, { minimumFractionDigits: 2 })}</td>
        </tr>)}</tbody></table></div>
        <label className="row gap-8 mt-16"><input type="checkbox" checked={confirmed} onChange={(event: any) => setConfirmed(event.target.checked)}/>{t('journalRecovery.confirmOpening')}</label>
      </div>}
    </Modal>
  </div>;
}
Object.assign(window, { ImportedOpeningRecovery: ImportedOpeningRecoveryView });
